import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "radio-button-checked",
  "use": "radio-button-checked-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"radio-button-checked\"><style>#radio-button-checked .st0{fill:#46a8f6}</style><path class=\"st0\" d=\"M12 3c5 0 9 4 9 9s-4 9-9 9-9-4-9-9 4-9 9-9m0-1C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2z\" /><circle class=\"st0\" cx=\"12\" cy=\"12\" r=\"6\" /><path d=\"M0 0h24v24H0V0z\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol